const ORG_TYPES = {
  office: 'Office',
  // residential: 'Residential', hospitality: 'Hospitality'
};

export default ORG_TYPES;
